var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#00A9DF",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.22,
    cx: 12.55,
    cy: 12.55,
    r: 12.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78 7.87v8.75l5.73-4.38-5.73-4.37z",
    strokeWidth: 1.38
  }))));
};
export { SvgPlayIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjcgMjciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgc3Ryb2tlPSIjMDBBOURGIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGNpcmNsZSBzdHJva2Utd2lkdGg9IjEuMjIiIGN4PSIxMi41NSIgY3k9IjEyLjU1IiByPSIxMi41NSIvPgogICAgPHBhdGggZD0iTTEwLjc4IDcuODd2OC43NWw1LjczLTQuMzgtNS43My00LjM3eiIgc3Ryb2tlLXdpZHRoPSIxLjM4Ii8+CiAgPC9nPgo8L3N2Zz4K";